export default "__VITE_ASSET__CWehc3dA__"